
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonSpinner, IonIcon, IonButton, modalController, IonButtons, menuController } from "@ionic/vue";
import { add, refresh, menu } from "ionicons/icons";
import { ref, onMounted } from "vue";

import { LOCALSTORAGE_KEY } from "@/custom_config";

import moment from "moment";

import { dateFormat } from "@/services/utils";
import { openToast } from "@/services/toast";

import apiRapportini from "@/services/rapportini";
import apiImpostazioniRapportini from "@/services/impostazioni_rapportini";
import apiAppuntamenti from "@/services/appuntamenti_squadre";

import NuovoRapportino from "@/components/rapportini/NuovoRapportino.vue";
//import ModificaRapportino from "@/components/rapportini/ModificaRapportino.vue";
import DettaglioRapportino from "@/components/rapportini/DettaglioRapportino.vue";

export default {
    name: "Rapportini",
    components: {
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonPage,
        IonSpinner,
        IonIcon,
        IonButton,
        IonButtons,
    },
    setup() {
        const loading = ref(false);
        const userID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_user_id;
        const dipendenteID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_id;

        const openMenu = () => {
            menuController.open("app-menu");
        };

        const totalMesePrecedente = ref(0);
        const totalMeseCorrente = ref(0);

        function calculateWorkedHours(rapportini) {
            totalMesePrecedente.value = 0; // Resetta i valori a zero
            totalMeseCorrente.value = 0; // Resetta i valori a zero

            rapportini.forEach((rapportino) => {
                const start = moment(`${rapportino.rapportini_data} ${rapportino.rapportini_ora_inizio}`);
                const end = moment(`${rapportino.rapportini_data} ${rapportino.rapportini_ora_fine}`);
                const diff = moment.duration(end.diff(start)).asMinutes(); // Usa minuti per maggiore precisione

                const meseRapportino = Number(moment(rapportino.rapportini_data).format("M"));
                const annoRapportino = Number(moment(rapportino.rapportini_data).format("YYYY"));
                const meseCorrente = Number(moment().format("M"));
                const annoCorrente = Number(moment().format("YYYY"));

                if (annoRapportino === annoCorrente) {
                    if (meseRapportino === meseCorrente - 1) {
                        totalMesePrecedente.value += diff;
                    } else if (meseRapportino === meseCorrente) {
                        totalMeseCorrente.value += diff;
                    }
                }
            });

            totalMesePrecedente.value = totalMesePrecedente.value / 60; // Converti in ore con due decimali
            totalMeseCorrente.value = totalMeseCorrente.value / 60; // Converti in ore con due decimali
        }

        const rapportini = ref([]);
        async function loadRapportini() {
            loading.value = true;
            totalMesePrecedente.value = 0;
            totalMeseCorrente.value = 0;
            try {
                const response = await apiRapportini.getRapportini(userID);
                if (response.status === 200 && response.data.status === 0) {
                    rapportini.value = response.data.data;
                    calculateWorkedHours(response.data.data);
                } else {
                    openToast("Si è verificato un errore durante la richiesta dei rapportini", "toast_danger");
                }
            } catch (error) {
                console.error(error);
                openToast("Si è verificato un errore durante la richiesta dei rapportini", "toast_danger");
            }
            loading.value = false;
        }

        /**
         * ! Set correct customer data
         */
        const riferimentoCliente = (intervento) => {
            if (intervento.customers_company) {
                return intervento.customers_company;
            } else if (intervento.customers_name && !intervento.customers_last_name) {
                return `${intervento.customers_name}`;
            }
            return `${intervento.customers_name} ${intervento.customers_last_name}`;
        };

        /**
         * 
         * ! Open rapportino detail
         * 
         */
         async function openDetail(rapportino) {
            const modal = await modalController.create({
                component: DettaglioRapportino,
                componentProps: {
                    data: rapportino,
                },
            });
            return modal.present();
        }

        /**
         * ! Open modal to create new intervento
         */
        async function openNuovoRapportino() {
            const modal = await modalController.create({
                component: NuovoRapportino,
            });
            modal.onDidDismiss().then((detail) => {
                if (detail.data != undefined) {
                    rapportini.value.unshift(detail.data);
                    calculateWorkedHours(rapportini.value);
                    // Redirect al dettaglio rapportino appena creato
                    openDetail(detail.data);
                    openToast("Nuovo rapportino salvato con successo", "toast_success");
                }
            });
            return modal.present();
        }

       /*  async function openEditRapportino(rapportino) {
            //console.log(rapportino);
            const creazione_rapportino = moment(rapportino.rapportini_creation_date);
            const now = moment(new Date());
            const difference = moment.duration(now.diff(creazione_rapportino));

            //Permetto modifica entro le 24 ore dalla creazione
            if (difference.days() >= 1 || difference.hours() >= 24) {
                openToast("La modifica del rapportino è consentita entro 24 ore dalla sua creazione", "toast_danger");
            } else {
                const modal = await modalController.create({
                    component: ModificaRapportino,
                    componentProps: {
                        data: rapportino,
                    },
                });

                modal.onDidDismiss().then((detail) => {
                    //console.log(detail);
                    if (detail.data != undefined) {
                        const edited = rapportini.value.find((el) => el.rapportini_id === detail.data.rapportini_id);
                        //console.log(edited);
                        if (edited) {
                            edited.rapportini_ora_inizio = detail.data.rapportini_ora_inizio;
                            edited.rapportini_ora_fine = detail.data.rapportini_ora_fine;
                            edited.rapportini_note = detail.data.rapportini_note;

                            openToast("Rapportino modificato con successo", "toast_success");
                        }
                    }
                });

                return modal.present();
            }
        } */

        const totalOrePreviste = ref(0);
        async function loadOrePianificate() {
            // Ottengo primo ed ultimo giorno del mese corrente nel formato yyyy-mm-dd
            const firstDay = moment().startOf('month').format('YYYY-MM-DD');
            const lastDay = moment().endOf('month').format('YYYY-MM-DD');            

            try {
                const response = await apiAppuntamenti.getAppuntamentiMese(userID, firstDay, lastDay);

                if (response.status === 0 && response.data.length > 0) {
                    // Calcolo ore previste mese corrente
                    totalOrePreviste.value = response.data.reduce((totale, app) => {
                        if (!app.appuntamenti_ora_inizio || !app.appuntamenti_ora_fine) {
                            return totale;
                        }
                        const [inizioOre, inizioMin] = app.appuntamenti_ora_inizio.split(':').map(Number);
                        const [fineOre, fineMin] = app.appuntamenti_ora_fine.split(':').map(Number);
                        const ore = (fineOre * 60 + fineMin - (inizioOre * 60 + inizioMin)) / 60;
                        return totale + ore;
                    }, 0);
                }
            } catch (error) {
                console.error(error);
                openToast("Si è verificato un errore durante la richiesta delle ore pianificate", "toast_danger");
            }
        }

        const mostra_counters_rapportini = ref(true);
        //const mostra_counters_rapportini = ref(false);
        async function loadImpostazioni() {
            try {
                const response = await apiImpostazioniRapportini.getImpostazioni();
                if (response.status === 200 && response.data.status === 0) {                    
                    if(response.data.data.length > 0) {
                        if(response.data.data[0].impostazioni_rapportini_mostra_contatori == '1') {
                            // Counter rapportini
                            mostra_counters_rapportini.value = true;
                        } else {
                            // Counter ore previste e rapportini
                            mostra_counters_rapportini.value = false;
                            loadOrePianificate();
                        }
                    }
                } else {
                    openToast("Si è verificato un errore durante la richiesta delle impostazioni", "toast_danger");
                }
                
            } catch (error) {
                console.error(error);
                openToast("Si è verificato un errore durante la richiesta delle impostazioni", "toast_danger");
            }
        }

        onMounted(() => {
            loadImpostazioni();
            loadRapportini();
        });

        return {
            loading,
            add,
            refresh,
            openNuovoRapportino,
            openMenu,
            menu,
            //Dati rapportini
            loadRapportini,
            rapportini,
            dateFormat,
            riferimentoCliente,
            //Modifica rapportino
            //openEditRapportino,
            //Dettaglio rapportino
            openDetail,
            // Counters
            mostra_counters_rapportini,
            totalMesePrecedente,
            totalMeseCorrente,
            totalOrePreviste
        };
    },
};
